import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

export function usePostContractAgreementRequest({
  callApiWithWorker,
  t,
  useProviderConnector = false,
  showSuccess = true,
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createContractAgreementRequest"],
    mutationFn: async () => {
      return callApiWithWorker(`/contractagreements/request`, {
        method: "POST",
        connector: "springConnector",
        useRuntimePort: !useProviderConnector,
        useRoleBasedConnectorRouting: !useProviderConnector,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contractAgreementRequest"] });

      if (!showSuccess) return;

      showSuccessToast(t("createdSubMessage", "Creation successfully"), {
        title: t("createdMessage", "Contract request created"),
      });
    },
    onError: (error) => {
      console.error("Error creating contract agreement request:", error);
      showErrorAlert(error, t);
    },
  });
}
